<adapt-configuration-page-base [configGroups]="configGroups"
                               configTitle="Organisation configuration"
                               (selectedItemChange)="selectedItem = $event">
    @switch (selectedItem?.area) {
        @case (ConfigArea.OrganisationProfile) {
            <adapt-configure-organisation-profile [configItem]="selectedItem"> </adapt-configure-organisation-profile>
        }
        @case (ConfigArea.CustomWelcomeEmail) {
            <adapt-configure-custom-welcome-email [configItem]="selectedItem"></adapt-configure-custom-welcome-email>
        }
        @case (ConfigArea.CalendarIntegration) {
            <adapt-configure-calendar-integration [configItem]="selectedItem"></adapt-configure-calendar-integration>
        }
        @case (ConfigArea.ExternalLink) {
            <adapt-configure-external-dashboard [configItem]="selectedItem"> </adapt-configure-external-dashboard>
        }
        @case (ConfigArea.Api) {
            <adapt-configure-api [configItem]="selectedItem"> </adapt-configure-api>
        }
        @case (ConfigArea.ObjectivesAndKeyResults) {
            <adapt-configure-objectives [configItem]="selectedItem"> </adapt-configure-objectives>
        }
        @case (ConfigArea.ValuesConstitution) {
            <adapt-configure-values-constitution [configItem]="selectedItem"> </adapt-configure-values-constitution>
        }
        @case (ConfigArea.PurposeAndVision) {
            <adapt-configure-purpose-and-vision [configItem]="selectedItem"> </adapt-configure-purpose-and-vision>
        }
        @case (ConfigArea.OwnersVision) {
            <adapt-configure-owners-vision [configItem]="selectedItem"></adapt-configure-owners-vision>
        }
        @case (ConfigArea.CareerValuation) {
            <adapt-configure-career-valuation [configItem]="selectedItem"> </adapt-configure-career-valuation>
        }
        @case (ConfigArea.CulturalIndex) {
            <adapt-configure-cultural-index [configItem]="selectedItem"> </adapt-configure-cultural-index>
        }
        @case (ConfigArea.CulturalLeadership) {
            <adapt-configure-cultural-leadership [configItem]="selectedItem"> </adapt-configure-cultural-leadership>
        }
        @case (ConfigArea.Tier1) {
            <adapt-configure-tier1 [configItem]="selectedItem"> </adapt-configure-tier1>
        }
        @case (ConfigArea.System) {
            <adapt-configure-systems [configItem]="selectedItem"> </adapt-configure-systems>
        }
        @case (ConfigArea.PeerCatchUp) {
            <adapt-configure-peer-catch-up [configItem]="selectedItem"> </adapt-configure-peer-catch-up>
        }
        @case (ConfigArea.Stakeholders) {
            <adapt-configure-stakeholders [configItem]="selectedItem"> </adapt-configure-stakeholders>
        }
        @case (ConfigArea.Kanban) {
            <adapt-configure-work [configItem]="selectedItem"> </adapt-configure-work>
        }
        @case (ConfigArea.Meetings) {
            <adapt-configure-meetings [configItem]="selectedItem"> </adapt-configure-meetings>
        }
        @case (ConfigArea.Labels) {
            <adapt-configure-labels [configItem]="selectedItem"></adapt-configure-labels>
        }
        @case (ConfigArea.PersonalProfileCategories) {
            <adapt-configure-personal-profile [configItem]="selectedItem"> </adapt-configure-personal-profile>
        }
        @case (ConfigArea.Team) {
            <adapt-configure-teams [configItem]="selectedItem"> </adapt-configure-teams>
        }
        @case (ConfigArea.EmployeeEngagement) {
            <adapt-configure-engagement [configItem]="selectedItem"> </adapt-configure-engagement>
        }
        @case (ConfigArea.TeamAssessment) {
            <adapt-configure-team-assessment [configItem]="selectedItem"> </adapt-configure-team-assessment>
        }
        @case (ConfigArea.ResilientBusinessAssessment) {
            <adapt-configure-resilient-business-assessment [configItem]="selectedItem"> </adapt-configure-resilient-business-assessment>
        }
        @case (ConfigArea.ResilientBusinessGoals) {
            <adapt-configure-resilient-business-goals [configItem]="selectedItem"> </adapt-configure-resilient-business-goals>
        }
        @case (ConfigArea.AI) {
            <adapt-configure-ai-assistant [configItem]="selectedItem"> </adapt-configure-ai-assistant>
        }
        @default {
            <adapt-configure-generic-feature [configItem]="selectedItem"></adapt-configure-generic-feature>
        }
    }
</adapt-configuration-page-base>
